import React from "react";
import { Modal, Button } from "react-bootstrap";

export const TemplateConfirmModal = ({ show, templateName, isMultiGroup, usesXspFallback, onConfirm, onCancel }) => {
    return (
        <Modal show={show} onHide={onCancel} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Apply Template</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isMultiGroup ? (
                    <>
                        <p>
                            Applying the <strong>{templateName}</strong> template will create multiple groups
                            with pre-configured trade settings including risk size, algorithms, and trading limits.
                            If any of the groups already exist, their settings will be overwritten.
                        </p>
                        <p>
                            After applying the template, you will still need to review the settings for each group,
                            make any necessary changes, and click Submit to save these changes.
                        </p>
                    </>
                ) : (
                    <>
                        <p>
                            Applying the <strong>{templateName}</strong> template will overwrite
                            the current group's trade settings including risk size, algorithms, and
                            trading limits.
                        </p>
                        <p>
                            After applying the template, you will still need to review the settings,
                            make any necessary changes, and click Submit to save these changes.
                        </p>
                    </>
                )}
                {usesXspFallback && (
                    <div className="border rounded p-2 mb-3 bg-light">
                        <p className="mb-1">
                            <strong>How SPX and XSP work in these groups:</strong>
                        </p>
                        <ul className="mb-0">
                            <li>
                                Groups that trade an SPX algorithm also include its XSP
                                equivalent as a fallback. <strong>SPX is always prioritized</strong> &mdash;
                                XSP is only used when the SPX trade cannot be placed.
                            </li>
                            <li>
                                If an SPX trade would collide with an existing position, it is
                                automatically redirected to XSP so your account can still get
                                into the trade.
                            </li>
                            <li>
                                Because XSP is 1/10 the size of SPX, the contract count is{' '}
                                <strong>automatically multiplied by 10</strong> when a trade falls
                                back to XSP (for example, 2 SPX contracts become 20 XSP contracts),
                                keeping your exposure equivalent.
                            </li>
                        </ul>
                    </div>
                )}
                <p>
                    <strong>
                        None of these templates turn trading on for you. To begin trading,
                        you need to turn on the Master On/Off Switch, turn trading on for the group, and select accounts to trade on for the group.
                    </strong>
                </p>
                <p>
                    Many of the templates don't enable Single Direction Trading by default. Make sure to enable Single Direction Trading
                    if the account(s) your connection is trading has a requirement to trade in the same direction across similar instruments.
                </p>
                <p>
                    <strong>IMPORTANT:</strong> You must review the settings applied by this template and make sure they
                    are right for your accounts and your situation. These templates are not tailored to your
                    financial situation, risk tolerance, or investment objectives. They are meant to help get you
                    up and running faster, but are not recommendations and should not be construed
                    as trading advice. Past performance is not indicative of future results. Trading options
                    and futures involves substantial risk of loss and is not suitable for all investors.
                </p>
                <p>
                    By clicking "I Understand", you acknowledge and agree to these statements and
                    to be bound by the <a href="/legal/terms" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onConfirm}>
                    I Understand
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
